import React, { useCallback, useContext } from 'react';
import { t } from 'i18next';
import { Button, ButtonStyle, ErrorBadge, ErrorLevel } from '@sovryn/ui';
import { useAccount } from '../../../../../../hooks/useAccount';
import { useMaintenance } from '../../../../../../hooks/useMaintenance';
import { translations } from '../../../../../../locales/i18n';
import { WithdrawContext, WithdrawStep, } from '../../../contexts/withdraw-context';
import { Instructions } from '../../Instructions';
export const MainScreen = () => {
    const { account } = useAccount();
    const { set } = useContext(WithdrawContext);
    const { checkMaintenance, States } = useMaintenance();
    const fastBtcLocked = checkMaintenance(States.FASTBTC);
    const onContinueClick = useCallback(() => set(prevState => (Object.assign(Object.assign({}, prevState), { step: WithdrawStep.AMOUNT }))), [set]);
    return (React.createElement("div", null,
        React.createElement(Instructions, null),
        fastBtcLocked ? (React.createElement(ErrorBadge, { level: ErrorLevel.Warning, message: t(translations.maintenanceMode.fastBtc) })) : (React.createElement(Button, { disabled: !account, onClick: onContinueClick, text: t(translations.common.buttons.continue), className: "w-full", style: ButtonStyle.secondary, dataAttribute: "funding-send-instructions-confirm" }))));
};
